<template>
  <form v-if="order" :action="order.pg_url" method="post">
    <input
      v-for="(value, key) in order"
      v-if="key !== 'pg_url'"
      type="hidden"
      :name="key"
      :value="value"
    />
    <v-btn type="submit" value="Pay Now" ref="paynow" id="paynow"></v-btn>
  </form>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "RenewSubscription",
  props: ["order"],
  mounted() {},
  data() {
    return {};
  },

  methods: {},
  computed: {
    ...mapState("userStore", ["user", "myInstitute"]),
  },

  watch: {
    order(val) {
      if (val) {
        this.$showLoader = true;
        setTimeout(() => {
          document.getElementById("paynow").click();
          this.$showLoader = false;
        }, 1000);
      }
    },
  },
};
</script>
